import { render, staticRenderFns } from "./PosOrder.vue?vue&type=template&id=f5f46d54&scoped=true&"
import script from "./PosOrder.vue?vue&type=script&lang=js&"
export * from "./PosOrder.vue?vue&type=script&lang=js&"
import style0 from "./PosOrder.vue?vue&type=style&index=0&id=f5f46d54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f46d54",
  null
  
)

export default component.exports